import { gql } from "@apollo/client";

const GET_ZONES = gql`
  query zones(
    $params: QueryParams
    $name: String
  ) {
    zones(
      params: $params
      name: $name
    ) {
      info {
        count
      }
      results {
        id
        name
        subZones {
          id
          name
        }
        createdAt
      }
    }
  }
`;

export { GET_ZONES };
